jQuery( function( $ ) {
	$( document ).ready( function() {

		/**
		 * Content for regulations is loaded from external link as html.
		 * I had to build function which will parse this html and create navigation.
		 *
		 * @author PH
		 */
		regulationsJS = ( function() {

			var
				_content = $( '#tr-text-js' ),

				_menu = $( '#tr-menu-js' ),

				init = function() {
					var _menuHTML = '';

					_content.find( '.type-privacy-policy > ol > li' ).each( function( i, obj ) {
						var
							title = $( obj ).find( '> p > strong' ).html(),
							index = $( obj ).index();

						$( obj ).attr( 'id', index );

						_menuHTML += '<li><a href="#' + index + '">' + title + '</a></li>';
					});

					_content.find( '.type-regulations .section-name' ).each( function( i, obj ) {
						_menuHTML += '<li><a href="#' + $( obj ).attr( 'id' ) + '">' + $( obj ).html() + '</a></li>';
					});

					_menu.html( _menuHTML );
				}
			;

			return {
				init: init
			};

		}() );

	});
});
